// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","ultra":"_3laM3i_Iso5RehVpSOt18W","body":"_2lYHSCAcM6vA2s-47YYZeS","headline":"_2VZ8OfV6pCjbZciF18Vn1A","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","container":"_3jtl8ea_3DptBd7tJWn9AP","title":"_2zmp-yDq9F1kxDc_UiM0-e _3laM3i_Iso5RehVpSOt18W","questionAmount":"_93pzCTyurkGYCEZ1fDf8s _2lYHSCAcM6vA2s-47YYZeS","questionCategory":"_1q4KebVCJevcmo0aXAdOBL _2VZ8OfV6pCjbZciF18Vn1A"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/faq-section/FAQSection.css
// module id = 988
// module chunks = 1